/**
 * @fileoverview POST handler for the "/engagement/campaigns/:app_group_id/update_tags" endpoint
 */
/* eslint-disable camelcase */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsUpdateTagsCacheKeys } from "./constants";
import type { CampaignsUpdateTagsParams, CampaignsUpdateTagsResult } from "./types";

export const postEngagementCampaignsUpdateTags = reactQueryMutationAdapter(
  engagementCampaignsUpdateTagsCacheKeys,
  ({
    app_group_id,
    desired_state,
    undo_identifier,
  }: CampaignsUpdateTagsParams): Promise<CampaignsUpdateTagsResult> => {
    // manipulate props here as needed {  }

    return fetch(`/engagement/campaigns/${app_group_id}/update_tags`, "POST", {
      desired_state,
      undo_identifier,
    });
  }
);
